import _createClass from "@babel/runtime/helpers/esm/createClass";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
var Image = /*#__PURE__*/_createClass(function Image(options) {
  _classCallCheck(this, Image);
  this.type = options.type || 'image';
  this.data = options.data || {
    src: ''
  };
  this.children = options.children || [{
    text: ''
  }];
});
var generateImage = function generateImage(options) {
  return Object.assign({}, new Image(options));
};
export default generateImage;